import { ICellRendererParams } from '@ag-grid-community/core';
import { ILoadBoardViewModel } from '@store/loadboard';
import { Show } from 'solid-js';
import { toggleRateCon } from '@store/orders';

const RateConCellRenderer = (
  data: ICellRendererParams<ILoadBoardViewModel>,
) => {
  return (
    <Show when={data.data} fallback={<></>}>
      <div class="flex items-center justify-center">
        <input
          type="checkbox"
          class="w-4 h-4 accent-[#123b50] checked:opacity-100 opacity-25 hover:cursor-pointer"
          checked={Boolean(data.data?.confirmationSigned)}
          onChange={() => {
            let recieved: boolean;
            if (Boolean(data.data?.confirmationSigned)) {
              recieved = false;
            } else {
              recieved = true;
            }
            void toggleRateCon(data.data?.loadId as number, recieved);
          }}
        />
      </div>
    </Show>
  );
};

export default RateConCellRenderer;
